export let url = 'https://alga.by/fitness_widget/api';

if (process.env.NODE_ENV === 'development') {
    url = 'https://alga.by/test_fitness_widget/api';
}